import { render, staticRenderFns } from "./DeleteView.vue?vue&type=template&id=2ff4b1b1&scoped=true"
import script from "./DeleteView.vue?vue&type=script&lang=js"
export * from "./DeleteView.vue?vue&type=script&lang=js"
import style0 from "./DeleteView.vue?vue&type=style&index=0&id=2ff4b1b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff4b1b1",
  null
  
)

export default component.exports